export const normalizeMsisdn = (msisdn) => {
  if (!msisdn) return msisdn;
  const digits = msisdn.replace(/\D/g, '');
  if (digits.startsWith('0')) {
    return `92${digits.slice(1)}`;
  }
  return digits;
};
